module.exports = __webpack_public_path__ + "img/capacitor-happy.59554a9c.jpg";